import { Field, FieldProps, getIn } from "formik";

import { PriceBlock, PriceValueType } from "../base";
import { Path } from "./types";

type FormPriceBlockProps<T> = {
  name: Path<T>;
  customLabel?: string;
  disabledTaxRate?: boolean;
};

export const FormPriceBlock = <T,>({
  name,
  customLabel,
  disabledTaxRate,
}: FormPriceBlockProps<T>) => {
  return (
    <Field name={name}>
      {({ field, form, meta: { touched } }: FieldProps<PriceValueType>) => {
        const error = getIn(form.errors, name);

        return (
          <PriceBlock
            value={field.value}
            onChange={(value) => {
              form.setFieldValue(name, value);
            }}
            customLabel={customLabel}
            disabledTaxRate={disabledTaxRate}
            exTaxError={touched && error?.exTaxPrice}
            incTaxError={touched && error?.incTaxPrice}
            taxRateError={touched && error?.salesTaxRate}
          />
        );
      }}
    </Field>
  );
};
